import { NotFound } from '@kkf/design'
import { useShellContent } from '../hooks/useShellContent'
import { SITE } from '../data/seo'

/**
 * The 404, in the reader's language.
 *
 * One component below `App` for the same reason `SiteShell` is: `App` renders
 * `LocaleProvider` and cannot read it. `NotFound` calls `usePreloader()` itself, so this
 * only resolves the words.
 */
export function NotFoundScreen() {
  const { notFound } = useShellContent()
  return <NotFound {...notFound} site={SITE} />
}
